<template>
  <registration-request-layout
    :requestId="requestId"
    :onRequestProcessed="onRequestProcessed"
    :getRegistrationRequestById="workflowService.getCreateAffiliateRequestById"
    :approveRegistrationRequest="workflowService.approveCreateAffiliateRequest"
    :denyRegistrationRequest="workflowService.denyCreateAffiliateRequest"
    :signSignatureByAdminFn="workflowService.signCreateAffiliateSignatureByAdmin"
    :markPaidByAdminFn="workflowService.markCreateAffiliatePaidByAdmin"
    :setRegistrationData="(registration) => (this.registration = registration)"
  >
    <create-affiliate-request
      :registration="registration"
    ></create-affiliate-request>
  </registration-request-layout>
</template>

<script lang="ts">
import Vue from "vue";
import CreateAffiliateRequest from "@/components/Portal/MyRequest/CreateAffiliateRequest.vue";
import RegistrationRequestLayout from "@/components/common/RegistrationRequestLayout.vue";
import workflowService from "@/services/admin/workflowService";

export default Vue.extend({
  name: "CreateAffiliateCard",
  props: {
    requestId: { type: Number },
  },
  components: {
    RegistrationRequestLayout,
    CreateAffiliateRequest,
  },
  data: function () {
    return {
      registration: {
        workflowGuid: "",
        requestId: 0,
      } as any,
    };
  },
  computed: {
    workflowService() {
      return workflowService;
    },
  },
  methods: {
    onRequestProcessed: function (requestId: number) {
      this.$navigate({ path: `/admin/registration/affiliate` });
    },
  },
});
</script>
